import React from 'react'
import { withOktaAuth } from "@okta/okta-react";
import { getSectionList, getContributorList } from "../../helpers/api";
import Placeholder from "../misc/placeholder";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Badge } from "react-bootstrap";

const PrintModule = (props) => {
  const [contributors, setContributors] = React.useState(null);
  const [sections, setSections] = React.useState(null);
  const [selectedSections, selectSection] = React.useState([]);

  const customSections = [
    {
      id: "e",
      label: "List of Entities",
    },
    {
      id: "c",
      label: "Contact List",
    },
    {
      id: "fa",
      label: "Approved Project List",
    },
    {
      id: "pp",
      label: "Pipeline Project List",
    },
    {
      id: "r",
      label: "Readiness Projects",
    },
  ];
  const [selectedCustomSections, selectCustomSections] = React.useState([]);

  const [selectedContributors, selectContributor] = React.useState([]);
  //const [_sectionValue] = React.useState("")

  React.useEffect(() => {
    getContributorList().then((data) => setContributors(data));
    getSectionList().then((data) => {
      if (data.length) {
        data = data.map((d) => {
          if (
            data.filter((dd) => dd.ParentID === d.ContributorSectionID).length
          ) {
            //has childs
            d.hasChildren = true;
          }
          if (d.ParentID) {
            d.Title = "".concat(
              data.filter((dd) => dd.ContributorSectionID === d.ParentID)[0]
                .Title,
              " → ",
              d.Title
            );
          }
          return d;
        });
      }
      setSections(data);
    });
  }, []);

  const onChangeSections = (id, remove = false) => {
    //console.log(id, remove)
    if (
      !id ||
      (!remove &&
        selectedSections.filter((s) => +s.ContributorSectionID === +id).length)
    ) {
      return true;
    }
    const value = remove
      ? selectedSections.filter((s) => s.ContributorSectionID !== id)
      : selectedSections.concat(
          sections.filter((s) => +s.ContributorSectionID === +id)[0]
        );
    //console.log({ value })
    selectSection(value);
  };

  const onChangeCustomSections = (id, remove = false) => {
    //console.log(id, remove)
    if (
      !id ||
      (!remove && selectedCustomSections.filter((s) => s.id === id).length)
    ) {
      return true;
    }
    const value = remove
      ? selectedCustomSections.filter((s) => s.id !== id)
      : selectedCustomSections.concat(
          customSections.filter((s) => s.id === id)[0]
        );
    //console.log({ value })
    selectCustomSections(value);
  };

  const onChangeContributors = (id, remove = false) => {
    if (
      !id ||
      (!remove &&
        selectedContributors.filter((s) => +s.ContributorID === +id).length)
    ) {
      return true;
    }
    const value = remove
      ? selectedContributors.filter((c) => c.ContributorID !== id)
      : selectedContributors.concat(
          contributors.filter((s) => +s.ContributorID === +id)[0]
        );
    selectContributor(value);
  };

  const sections_params =
    selectedSections.map((s) => s.ContributorSectionID).join(",") || "null";
  const custom_params =
    selectedCustomSections.map((s) => s.id).join(",") || "null";

  const ready_for_printing = !(
    selectedContributors.length === 0 ||
    (selectedSections.length === 0 && selectedCustomSections.length === 0)
  );

  return props.is_user_editor ? (
    <div className="container mt-2">
      <div className="row">
        <div className="col">
          <h4>Custom Section Printing</h4>
        </div>
      </div>
      <div className="row">
        <div className="col col-xs-12">
          {sections ? (
            <div className="form-group">
              <label>1. Select sections</label>
              <select
                name="sections"
                className="form-control"
                value={""}
                onChange={(e) => onChangeSections(e.target.value)}
              >
                <option value="">Select a section...</option>
                {sections
                  .filter(
                    (s) =>
                      selectedSections
                        .map((ss) => ss.ContributorSectionID)
                        .indexOf(s.ContributorSectionID) === -1
                  )
                  .map((section, idx) => (
                    <option key={idx} value={section.ContributorSectionID}>
                      {section.Title} {section.Confidential ? "*" : null}{" "}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            <Placeholder />
          )}
        </div>
        <div className="col-12 col-sm">
          {sections && customSections ? (
            <div className="form-group">
              <label>2. Select custom sections</label>
              <select
                name="sections"
                className="form-control"
                value={""}
                onChange={(e) => onChangeCustomSections(e.target.value)}
              >
                <option value="">Select a custom section...</option>
                {customSections
                  .filter(
                    (s) =>
                      selectedCustomSections
                        .map((ss) => ss.id)
                        .indexOf(s.id) === -1
                  )
                  .map((section, idx) => (
                    <option key={idx} value={section.id}>
                      {section.label}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            <Placeholder />
          )}
        </div>
        <div className="col-12 col-sm">
          {contributors ? (
            <div className="form-group">
              <label>3. Select Contributors</label>
              <select
                name="contributors"
                className="form-control"
                onChange={(e) => onChangeContributors(e.target.value)}
              >
                <option value="">Select a contributor...</option>
                {contributors.map((contributor, idx) => (
                  <option key={idx} value={contributor.ContributorID}>
                    {contributor.ContributorName}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <Placeholder />
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm">
          <hr />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-12 col-sm">
          <p>Selected Sections</p>
          {selectedSections.length > 0 ? (
            <ul className="list-inline">
              {selectedSections.map((section) => (
                <li
                  key={section.ContributorSectionID}
                  className="list-inline-item"
                >
                  <Badge pill bg="primary" className="">
                    {section.Title}{" "}
                    <i
                      onClick={() =>
                        onChangeSections(section.ContributorSectionID, true)
                      }
                      className="fas fa-times text-button d-inline-block"
                    />
                  </Badge>
                </li>
              ))}
            </ul>
          ) : (
            <p>No sections</p>
          )}
        </div>
        <div className="col-12 col-sm">
          <p>Selected Custom Sections</p>
          {selectedCustomSections.length > 0 ? (
            <ul className="list-inline">
              {selectedCustomSections.map((section) => (
                <li key={section.id} className="list-inline-item">
                  <Badge pill bg="info">
                    {section.label}{" "}
                    <i
                      onClick={() => onChangeCustomSections(section.id, true)}
                      className="fas fa-times text-button d-inline-block"
                    />
                  </Badge>
                </li>
              ))}
            </ul>
          ) : (
            <p>No custom sections</p>
          )}
        </div>
        <div className="col-12 col-sm">
          <p>Selected Contributors</p>
          {selectedContributors.length > 0 ? (
            <ul className="list-inline">
              {selectedContributors.map((c) => (
                <li key={c.ContributorID} className="list-inline-item">
                  <Badge pill bg="secondary" className="badge-xl">
                    {c.ContributorName}{" "}
                    <i
                      onClick={() =>
                        onChangeContributors(c.ContributorID, true)
                      }
                      className="fas fa-times text-button d-inline-block"
                    />
                  </Badge>
                </li>
              ))}
            </ul>
          ) : (
            <p>No sections</p>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <hr />
          {!ready_for_printing && (
            <p className="alert alert-info">
              <i className="fas fa-info-circle" /> You must select at least one
              contributor and at least one of either sections or custom sections
              to generate the print page.
            </p>
          )}
          <div className="form-group">
            <Link
              to={`/modules/print/contributors/${selectedContributors
                .map((c) => c.ContributorID)
                .join(
                  ","
                )}/sections/${sections_params}/custom/${custom_params}`}
              className={`btn btn-info ${
                !ready_for_printing ? "disabled" : ""
              }`}
            >
              <i className="fas fa-search" /> Prepare Report
            </Link>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = ({ okta }) => {
  return {
    is_user_editor: okta.is_user_editor,
  };
};

export default withOktaAuth(connect(mapStateToProps)(PrintModule));